import React from "react";
import { useQuery } from "@tanstack/react-query";
import ProductCard from "../components/products/ProductCard";

type Product = {
  _id: string;
  title: string;
  description: string;
  price: number;
  images: string[];
  colors: string[];
  sizes: string[];
  stockBySize: Record<string, number>;
};

const apiUrl = process.env.REACT_APP_API_URL;


const fetchProducts = async (): Promise<Product[]> => {
  const res = await fetch(`${apiUrl}/api/products`);
  if (!res.ok) throw new Error("Erreur de récupération");
  return res.json();
};

export default function Articles() {
  const {
    data = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["products"],
    queryFn: fetchProducts,
  });

  if (isLoading) return <div className="text-center py-12">Chargement...</div>;
  if (isError) return <div className="text-center py-12">Erreur serveur</div>;

  return (
    <section className="max-w-6xl mx-auto px-4 py-12">
      <div
        className={`grid gap-10 place-items-center ${
          data.length === 1
            ? "grid-cols-1"
            : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
        }`}
      >
        {data.map((product) => (
          <ProductCard key={product._id} product={product} />
        ))}
      </div>
    </section>
  );
}
